/* src/app/work/work.component.css */
.work-section {
  background: #f7f8fa;
}
.work-tabs-shell {
  margin: 2rem 0 1rem;
}
.work-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.6rem;
  margin: 0 -0.25rem;
  padding: 0.25rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.work-tabs::-webkit-scrollbar {
  display: none;
}
.work-tabs-arrow {
  display: none;
}
.work-tab {
  flex: 0 0 auto;
  min-height: 44px;
  padding: 0 0.95rem;
  border: 1px solid #e2e7ef;
  border-radius: 6px;
  background: #ffffff;
  color: #364152;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(23, 50, 77, 0.04);
  opacity: 0.76;
  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    color 0.18s ease,
    opacity 0.18s ease,
    transform 0.18s ease;
}
.work-tab-adjacent {
  background: #ffffff;
  color: #364152;
  opacity: 0.92;
}
.work-tab-distant {
  background: #fafbfc;
  color: #7a8797;
  opacity: 0.72;
}
.work-tab-far {
  background: #f3f5f8;
  color: #9aa4b2;
  opacity: 0.58;
}
.work-tab:hover,
.work-tab:focus {
  border-color: #1e87f0;
  color: #1e87f0;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(23, 50, 77, 0.08);
  opacity: 1;
  outline: none;
  transform: translateY(-1px);
}
.work-tab-active {
  background: #17324d;
  border-color: #17324d;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(23, 50, 77, 0.16);
  opacity: 1;
}
.work-tab-active:hover,
.work-tab-active:focus {
  background: #17324d;
  border-color: #17324d;
  color: #ffffff;
}
.work-tab:active {
  color: #1e87f0;
}
.work-tab-active:active {
  background: #17324d;
  color: #ffffff;
}
.work-panel {
  padding: 2rem;
  background: #ffffff;
  border: 1px solid #e2e7ef;
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(23, 50, 77, 0.08);
}
.work-logo {
  width: 72px;
  height: 72px;
  object-fit: contain;
  border-radius: 6px;
  background: #ffffff;
}
.work-logo-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #17324d;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(23, 50, 77, 0.06);
}
.work-panel h2 {
  margin: 0;
  color: #172033;
  font-size: 1.45rem;
  line-height: 1.2;
}
.work-panel-grid {
  display: grid;
  grid-template-columns: minmax(220px, 0.8fr) minmax(0, 1.4fr);
  gap: 2rem;
}
.work-panel h3 {
  margin: 0 0 1rem;
  color: #172033;
  font-size: 1rem;
  font-weight: 700;
}
.work-identity {
  padding-right: 2rem;
  border-right: 1px solid #edf0f4;
}
.work-identity-header {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 1rem;
  align-items: center;
  padding-bottom: 0.75rem;
}
.work-role {
  position: relative;
  margin-top: 0.75rem;
  padding: 0.85rem 0 0.85rem 0.9rem;
  border-left: 2px solid #edf0f4;
  opacity: 0.62;
}
.work-role:first-of-type {
  margin-top: 1rem;
}
.work-role-primary {
  border-left-color: #1e87f0;
  opacity: 1;
}
.work-role-title {
  margin: 0;
  color: #253247;
  font-weight: 700;
}
.work-role-note {
  margin: 0.25rem 0 0;
  color: #526070;
  font-size: 0.9rem;
}
.work-role-time {
  margin: 0.25rem 0 0;
  color: #7a8797;
  font-size: 0.9rem;
}
.work-role-location {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  margin-left: 0.5rem;
  padding: 0 0.45rem;
  border: 1px solid #d8dde6;
  border-radius: 999px;
  color: #526070;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
}
.work-description p {
  margin: 0;
  color: #3f4c5f;
  font-size: 1rem;
  line-height: 1.75;
}
.work-publication {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #edf0f4;
}
.work-publication h3 {
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
}
.work-publication a {
  color: #1e5f9f;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.45;
}
.work-publication span {
  display: inline-block;
  margin-right: 0.35rem;
  color: #526070;
  font-size: 0.75rem;
  font-weight: 700;
}
@media (max-width: 760px) {
  .work-tabs-shell {
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr) 36px;
    gap: 0.4rem;
    align-items: center;
    margin-top: 1.5rem;
  }
  .work-tabs {
    margin: 0;
    padding: 0.25rem 0;
  }
  .work-tabs-arrow {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 44px;
    border: 1px solid #e2e7ef;
    border-radius: 6px;
    background: #ffffff;
    box-shadow: 0 3px 10px rgba(23, 50, 77, 0.04);
    cursor: pointer;
  }
  .work-tabs-arrow::before {
    content: "";
    width: 9px;
    height: 9px;
    border-top: 2px solid #526070;
    border-right: 2px solid #526070;
  }
  .work-tabs-arrow-left::before {
    transform: rotate(-135deg);
  }
  .work-tabs-arrow-right::before {
    transform: rotate(45deg);
  }
  .work-tabs-arrow:hover,
  .work-tabs-arrow:focus {
    border-color: #1e87f0;
    outline: none;
  }
  .work-tabs-arrow:hover::before,
  .work-tabs-arrow:focus::before {
    border-color: #1e87f0;
  }
  .work-tab:hover,
  .work-tab:focus {
    transform: none;
  }
  .work-panel {
    padding: 1.25rem;
  }
  .work-panel-grid {
    grid-template-columns: 1fr;
  }
  .work-identity {
    padding-right: 0;
    padding-bottom: 1.25rem;
    border-right: 0;
    border-bottom: 1px solid #edf0f4;
  }
  .work-logo {
    width: 56px;
    height: 56px;
  }
  .work-identity-header {
    grid-template-columns: 56px minmax(0, 1fr);
  }
  .work-panel h2 {
    font-size: 1.5rem;
  }
}
/*# sourceMappingURL=work.component.css.map */
